const MARKET_WATCH_STORAGE_KEY = 'market_watch_symbols';
const DEFAULT_MARKET_WATCH_COUNT = 12;

export const normalizePriceSymbol = (symbol) => String(symbol || '').trim().toUpperCase();

export const getPriceSymbolCandidates = (symbol) => {
  const value = String(symbol || '').trim();
  if (!value) return [];

  const normalized = normalizePriceSymbol(value);

  return Array.from(new Set([
    value,
    normalized,
    value.toLowerCase(),
  ]));
};

export const getRealtimePrice = (prices, symbol) => {
  if (!prices || !symbol) return null;

  for (const candidate of getPriceSymbolCandidates(symbol)) {
    const price = prices[candidate];
    if (Number.isFinite(Number(price?.bid)) && Number.isFinite(Number(price?.ask))) {
      return price;
    }
  }

  return null;
};

export const hasRealtimePrice = (prices, symbol) => {
  return Boolean(getRealtimePrice(prices, symbol));
};

export const filterSymbolsByRealtimePrice = (symbols) => {
  return symbols || [];
};

export const getStoredMarketWatchSymbols = () => {
  try {
    const saved = localStorage.getItem(MARKET_WATCH_STORAGE_KEY);
    if (saved === null) return null;
    const parsed = JSON.parse(saved);
    return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : null;
  } catch {
    return null;
  }
};

export const getMarketWatchSymbols = (symbols, selectedSymbols = getStoredMarketWatchSymbols()) => {
  const allSymbols = filterSymbolsByRealtimePrice(symbols);

  if (selectedSymbols === null) return allSymbols.slice(0, DEFAULT_MARKET_WATCH_COUNT);

  const symbolMap = new Map(allSymbols.map(symbol => [symbol.symbol, symbol]));
  return selectedSymbols.map(symbol => symbolMap.get(symbol)).filter(Boolean);
};
